import React, { useEffect } from 'react';
import { acciones } from '../../json/acciones';
//import { rubrosHistoricosdos } from '../../json/rubrosHistoricosdos';
//import { informacionHistorica } from '../../json/informacionHistorica';
import './acciones.css';

const Acciones = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

  return (
    <div className='container'>
        <div className='row'>
            <div>
                <h3 className='title'>Acciones</h3>
                <hr className='hr-gob'/>
            </div>
                {
                acciones.map((item, index)=>(
                    <div key={ index } className='col-md-3 col-sm-6 col-12'>
                        <div className='card_container_acciones'>
                            <div className='card_cero'>
                                <h5>{ item.anio }</h5>
                                <h6>{ item.descripcion }</h6>
                                {
                                    item.trimestres.map((trim, index)=>(
                                        <div key={ index } className='card_trimestre'>
                                            <p>{ trim.trimestre } <span className="badge bg-secondary">
                                                <a href={ trim.url } target="_blank">Ingresar</a></span>
                                            </p> 
                                        </div>
                                ))
                                }
                            </div>
                        </div>
                    </div>
                    ))
                }

        </div>
    </div>
  )
}
export default Acciones